export const HOMESHARING_BACKEND_SERVICE_NAME = "lv-homesharing-backend-srv";
